export default "__VITE_ASSET__Cp8Rjs6O__"